import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Button from "~/ui/Button/Button";
import LanguageSwitcher from "./LanguageSwitcher";
import Dashboard from "~/features/Dashboard";

import { useHelperStore } from "~/stores";

const AppHeader = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const isFetching = useHelperStore(state => state.isLoading);
    const isAppInitialized = useHelperStore(state => state.isAppInitialized);
    const isLocked = isFetching || !isAppInitialized;

    // Displays the Marketing Intelligence in its new location
    const handleBtnClick = () => {
        navigate("/market-intelligence");
    };

    return (
        <div className="flex justify-end pt-3 px-10 pb-2 absolute right-0">
            <div className="flex gap-4 items-center">
                <Button
                    className="!bg-transparent !text-sm !text-stone-darkest font-medium-light focus:!outline-none"
                    onPress={handleBtnClick}
                    isDisabled={isLocked}
                >
                    <div className="leading-5">{t("marketIntelligence")}</div>
                </Button>

                <LanguageSwitcher />

                <Dashboard />
            </div>
        </div>
    );
};

export default AppHeader;
